import React from 'react';
import UserCard from './UserCard';

const UserGrid = ({ users, onRoleChange, currentUserId }) => {
  if (users.length === 0) {
    return (
      <div className="text-center py-16">
        <div className="w-24 h-24 bg-muted/30 rounded-full flex items-center justify-center mx-auto mb-6">
          <svg
            className="w-12 h-12 text-muted-foreground"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={1.5}
              d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        </div>
        <h3 className="text-xl font-semibold text-foreground mb-2">
          No users yet
        </h3>
        <p className="text-muted-foreground mb-6 max-w-md mx-auto">
          Add your first user to manage access to the system.
        </p>
      </div>
    );
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {users.map((user) => (
        <UserCard
          key={user.id}
          user={{ ...user, isCurrent: user.id === currentUserId }}
          onRoleChange={onRoleChange}
        />
      ))}
    </div>
  );
};

export default UserGrid;
